import { a as _applyDecoratedDescriptor, b as _initializerDefineProperty, _ as _defineProperty } from '../_rollupPluginBabelHelpers-ec67cb00.js';
import Component from '@glimmer/component';
import service from '../-private/service.js';
import { all } from 'rsvp';
import { modifier } from 'ember-modifier';
import './liquid-child.css';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div class=\"liquid-child {{@class}}\" data-liquid-child={{@uniqueChildId}}\n   ...attributes\n  {{this.setup}}\n>\n  {{~yield~}}\n</div>");

var _class, _descriptor;
let LiquidChildComponent = (_class = class LiquidChildComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "liquidFireChildren", _descriptor, this);
    _defineProperty(this, "element", null);
    _defineProperty(this, "_waitingFor", []);
    _defineProperty(this, "_isLiquidChild", true);
    _defineProperty(this, "_serviceElement", null);
    _defineProperty(this, "_didSetup", false);
    _defineProperty(this, "setup", modifier(element => {
      if (this._didSetup) {
        return;
      }
      this._didSetup = true;
      this.element = element;
      this._serviceElement = this.liquidFireChildren.register(this.args.uniqueChildId, this);
      element.style.visibility = 'hidden';
      this._waitForAll().then(() => {
        if (!this.isDestroying) {
          this.liquidFireChildren._waitingFor = [];
          const didRenderAction = this.args.liquidChildDidRender;
          if (typeof didRenderAction === 'function') {
            didRenderAction(this);
          }
        }
      });
    }));
  }
  willDestroy() {
    super.willDestroy();
    if (this._serviceElement) {
      this.liquidFireChildren.unregister(this._serviceElement);
      this._serviceElement = null;
    }
  }
  _waitForMe(promise) {
    if (!this.liquidFireChildren._waitingFor) {
      return;
    }
    this.liquidFireChildren._waitingFor.push(promise);
    const ancestor = this.liquidFireChildren.closest(this.element);
    if (ancestor) {
      ancestor._waitForMe(promise);
    }
  }
  _waitForAll() {
    const promises = this.liquidFireChildren._waitingFor;
    this.liquidFireChildren._waitingFor = [];
    return all(promises).then(() => {
      if (this.liquidFireChildren._waitingFor.length > 0) {
        return this._waitForAll();
      }
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "liquidFireChildren", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
setComponentTemplate(TEMPLATE, LiquidChildComponent);

export { LiquidChildComponent as default };
//# sourceMappingURL=liquid-child.js.map
